const config = {
    mainPlayer: {
        playerID: '01dxbn4x6241pnvh1p',
        playlistID: '01ffg462q76mr7e3x0'
    },
    voltaxView: {
      playerConfig: {

      },
      viewConfig: {
        title: 'The Players Tribune',
        logo: 'https://images2.minutemediacdn.com/image/upload/v1631544017/frontier/sites/logos/logo-round.png',
        darkMode: true,
      }
    },
    sections: [
        {id: '01ffg43wmf85kc3hwc', name: 'Basketball Videos'},
        {id: '01ffg3znhfmh71w9dv', name: 'Football Videos'},
        {id: '01ffg3szcra84vtymy', name: 'Global Videos'},
        {id: '01ffg3pwb54w33jwad', name: 'Other Sports'}
    ],
    header: {
        targetUrl: "https://www.theplayerstribune.com/",
        brandLogo: "https://dev.w3.org/SVG/tools/svgweb/samples/svg-files/AJ_Digital_Camera.svg", // not in use
        navigationCategories: [
            {name: "BASKETBALL", link: "https://www.theplayerstribune.com/sports/basketball"},
            {name: "FOOTBALL", link: "https://www.theplayerstribune.com/sports/football"},
            {name: "SOCCER", link: "https://www.theplayerstribune.com/sports/soccer"},
            {name: "HOCKEY", link: "https://www.theplayerstribune.com/sports/hockey"},
            {name: "BASEBALL", link: "https://www.theplayerstribune.com/sports/baseball"}
        ]
    },
    footer: {
        links: [
            {name: "ABOUT", link: "https://www.theplayerstribune.com/about"},
            {name: "ATHLETE APPLICATION", link: "https://www.theplayerstribune.com/athlete-contact-form"},
            {name: "CAREERS", link: "https://www.theplayerstribune.com/work-with-us"},
            {name: "PRIVACY", link: "https://www.theplayerstribune.com/privacy"},
            {name: "TERMS", link: "https://www.theplayerstribune.com/terms"},
            {name: "COOKIE POLICY", link: "https://www.theplayerstribune.com/cookies#"},
            {name: "NEWSLETTER", link: "https://www.theplayerstribune.com/connect"},
            {name: "ACCESSIBILITY STATEMENT", link: "https://www.theplayerstribune.com/accessibility-statement"},
        ],
        socialLinks: {
            facebook: "https://www.facebook.com/theplayerstribune",
            instagram: "https://www.instagram.com/playerstribune/",
            twitter: "https://twitter.com/playerstribune",
            rss: null,
            tiktok: "https://www.tiktok.com/@playerstribune",
            youtube: "https://www.youtube.com/user/playerstribune",
            linkedin: "https://www.linkedin.com/company/the-players-tribune"
        }
    }
}

export default config
